/**
 * Quiz score
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import {Scoreresult} from '../../common/components/displayItems/results.jsx';

import {tokenize} from '../utils/utils';

(function() {

  var ResultModel, ComponentView;

  // Build up the model for displaying the content + building the share context
  ResultModel = Backbone.Model.extend({

    parse: function(){

      var resultInfo = this.attributes;

      var getResultHeading = function(result){
          if (result.hasOwnProperty('category_title') && result.category_title) return result.category_title;
          if (result.hasOwnProperty('message')) return tokenize(result.message, {score: result.score, total: result.total});
          return tokenize(result.title, {score: result.score, total: result.total});
        },
        getResultByline = function(result){
          if (result.hasOwnProperty('byline') && result.byline) return result.category_title;
          return tokenize(result.title, {score: result.score, total: result.total});
        },
        getResultContent = function(result){
          if (result.hasOwnProperty('score') || result.hasOwnProperty('total')){
            return tokenize(result.description, {score: result.score, total: result.total});
          }
          return result.content;
        },
        getSharingConfig = function(result){
          var sharingKeys = [];
          _.each(['twitter', 'facebook'], function(_network){

            var shareInfo = {
              action:  'share',
              network: _network,
              context: 'result',
              title:   getResultHeading(result),
              message: result.shareMessage,
              link:    result.link || 'ctx:smarturl',
              picture: result.thumbnailAssetRef || result.imageAssetRef
            };

            sharingKeys.push(shareInfo);

            NGX.App.api.addShare({context: 'result', enabled: 'true', data: [shareInfo], network: _network});
          });

          return sharingKeys;
        };

      return {
        'assetRef': resultInfo.imageAssetRef,
        'assets':   {
          'main':      resultInfo.imageAssetRef,
          'thumbnail': resultInfo.thumbnailAssetRef
        },
        'caption':      '',
        'content':      getResultContent(resultInfo),
        'message':      resultInfo.message,
        'heading':      getResultHeading(resultInfo),
        'byline':       getResultByline(resultInfo),
        'link':         resultInfo.link || 'ctx:smarturl',
        'linkText':     resultInfo.linkText,
        'score':        resultInfo.score,
        'total':        resultInfo.total,
        'shareMessage': resultInfo.shareMessage,
        'itemOpts':     {
          'sharingKeys': getSharingConfig(resultInfo)
        }
      };

    }
  });

  ComponentView = Backbone.View.extend({

    el: '',

    initialize: function() {
      _.bindAll( this, 'reload' );

      this.$containerInner = this.$('.xComponentInner');
      this.resultModel = new ResultModel();

      this.listenTo(this.resultModel, 'change', function(){
        this.render();
      });

      if (this.model.get('result')){
        this.resultModel.set(this.model.get('result'));
      }

    },

    // reload the component on SPA confirmation state
    reload: function(){
      log.debug('Reloading component at '+this.el.id, 6);
      if ('object'===typeof NGX.App.state.entry){
        var _resultInfo = NGX.App.state.entry.quiz;
        var _newModel = {
          imageAssetRef:     _resultInfo.imageAssetRef,
          thumbnailAssetRef: _resultInfo.thumbnailAssetRef,
          message:           _resultInfo.message,
          description:       _resultInfo.description,
          shareMessage:      _resultInfo.shareMessage,
          category_title:    _resultInfo.category_title,
          score:             _resultInfo.score,
          total:             _resultInfo.total
        };
        this.resultModel.set(_newModel);
      }
    },

    render: function(){
      if (this.resultModel.attributes.hasOwnProperty('score')){
        var _resultModel = this.resultModel.parse();

        var result = React.createElement(Scoreresult, {item:         _resultModel, templateOpts: {
          itemTemplate:    'result',
          collectionClass: 'scoreresults',
          assetUrl:        NGX.context.assetUrl,
          assetUgcUrl:     NGX.context.assetUgcUrl
        }});

        createRoot(this.$containerInner[0]).render(result);
      }
      return this;
    }
  });

  NGX.comps.push({type: 'scoreresult', view: ComponentView});

}());
